<template>
  <div style="margin: 10px auto;width: 70%;">
    <el-card style="">
      <div v-html="item.content"></div>
    </el-card>





  </div>
</template>

<script>
export default {
  name: 'threeDetail',
  data() {
    return {
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      id: this.$route.query.id,
      item: {},
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get('/threed/' + this.id).then(res => {
        this.item = res.data
      })
    },
  }
}
</script>

<style>

</style>